import { ValidationRules, ValidationController, validateTrigger } from "aurelia-validation";
import FsUtility from "../../../../Lib/Fs.SmartClient.Client/FsUtility";
import { useView, autoinject, Container, computedFrom} from 'aurelia-framework';
import { Router } from 'aurelia-router'
import { BindingEngine } from 'aurelia-binding';
import ACLTemplateCategoryData from "../../../Core/Scripts/ACLTemplateCategoryData";
import ACLTemplateSearchParameter from "../../../Core/Scripts/AppServiceContract/ACLTemplateSearchParameter";
import ACLTemplateSearchCriteria from "../../../Core/Scripts/ACLTemplateSearchCriteria";
import ACLTemplateUpdateParameter from "../../../Core/Scripts/ACLTemplateUpdateParameter";
import ACLTemplateData from "../../../Core/Scripts/ACLTemplateData";
import ResourceData from "../../../Core/Scripts/ResourceData";
import ApplicationData01 from "../../../Core/Scripts/AppServiceContract/ApplicationData01";
import { fs } from "../../../../Config/FsConfig";
import ACLTemplateAppService from "../../../Core/Scripts/AppServiceContract/ACLTemplateAppService";
import ModuleData from "../../../Core/Scripts/AppServiceContract/ModuleData";

@autoinject
export default class PermissionVM {

    Categories: Array<PermissionCategoryVM>
    Temp: Array<ACLTemplateCategoryData>
    UserUID: string
    IsEditing: boolean = false;

    ModuleList: ModuleData[];
    selectedModule: ModuleData;
    get SelectedModule(): ModuleData {
        return this.selectedModule;
    };
    set SelectedModule(value: ModuleData) {
        this.selectedModule = value;
        this.Search();
    }

    selectedModuleId: string;
    get SelectedModuleId(): string {
        return this.selectedModuleId;
    }
    set SelectedModuleId(value: string) {
        this.selectedModuleId = value;
        if (value != null) {
            this.SelectedModule = this.ModuleList.find(t => t.Id == value);
        }
    }

    ModuleWidget: any;

    constructor(code) {
        var self = this;
        self.Categories = [];
        self.Temp = [];
        self.UserUID = code;
        self.Load(code);
        self.LoadApplicationList();
    }

    bind() {
        $(document).ajaxSend(function (event, jqXhr) {
            var user = Container.instance.get("user");
            if (user != null) {
                jqXhr.setRequestHeader('Authorization', 'Bearer ' + user.access_token);
            }
        });
    }

    BeginEdit() {
        if (this.IsEditing == true) return;
        this.IsEditing = true;
    }

    EndEdit() {
        if (this.IsEditing == false) return;
        this.IsEditing = false;
    }

    Load(code: string) {
        var self = this;
        if (code != null && code != 'undefined') {
            self.Search();
        }
    }

    LoadApplicationList() {
        var self = this;

        var service = Container.instance.get(ACLTemplateAppService) as ACLTemplateAppService;

        service.LoadModuleList().done(function (result) {
            var currentSystem = new ModuleData();
            currentSystem.Id = "0";
            currentSystem.Name = "Current System";
            currentSystem.BaseUrl = fs.Config.ServiceBaseUrl;
            self.ModuleList = result;
            self.ModuleList.unshift(currentSystem);
        }).fail(FsUtility.CommonErrorHandler);
    }

    Search() {
        var req = this.CreateCriteria();
        req.PagingCriteria = null;
        req.SortingCriteria = null;
        var service = Container.instance.get(ACLTemplateAppService) as ACLTemplateAppService;
        if (this.SelectedModule != null) {
            service.Init({ serverBaseUrl: this.SelectedModule.BaseUrl });
        }
        service.FindTemplate(req)
            .done((result) => {
                this.PrepareChildVMs(result);
            }).fail(FsUtility.CommonErrorHandler);
    }

    PrepareChildVMs(result: Array<ACLTemplateCategoryData>) {
        this.Categories = [];

        for (var i in result) {
            var categoryData = result[i];
            var newCategoryVM = new PermissionCategoryVM();
            newCategoryVM.Parent = this;
            newCategoryVM.LoadOriginalSource(categoryData);
            this.Categories.push(newCategoryVM);
        }
        this.Temp = result;
    }

    CreateCriteria() {
        var req = new ACLTemplateSearchParameter();
        var cri = new ACLTemplateSearchCriteria();

        cri.UserUID = this.UserUID;
        req.Criteria = cri;
        return req;
    }

    Save() {
        var req = this.CreateCriteria()
        var self = this;
        var items = new ACLTemplateUpdateParameter;
        items.UserUID = self.UserUID;
        items.Items = self.SelectedItems;

        var service = Container.instance.get(ACLTemplateAppService) as ACLTemplateAppService;
        if (this.SelectedModule != null) {
            service.Init({ serverBaseUrl: this.SelectedModule.BaseUrl });
        }
        service.SaveTemplate(items)
            .done(function (result) {

                service.FindTemplate(req)
                    .done((result) => {
                        self.Temp = result;
                    }).fail(FsUtility.CommonErrorHandler);


                FsUtility.AlertModal("The item has been saved successfully", 1, 1);

                self.EndEdit();
            }).fail(FsUtility.CommonErrorHandler);


    }

    Cancel() {
        for (var i = 0; i < this.Categories.length; i++) {
            var categoryVM = this.Categories[i];
            for (var j = 0; j < categoryVM.Templates.length; j++) {
                var templateVM = categoryVM.Templates[j];
                var isCheck = this.GetTempValue(templateVM.Id);
                var ResourceId = this.GetTempResourceValue(templateVM.Id);
                templateVM.ResourceId = ResourceId;
                templateVM.IsCheck = isCheck;
            }
        }
        this.EndEdit();
    }

    GetTempValue(aclTemplateId: string): boolean {
        for (var i = 0; i < this.Temp.length; i++) {
            var categoryTemp = this.Temp[i];
            for (var j = 0; j < categoryTemp.ACLTemplateDatas.length; j++) {
                var templateTemp = categoryTemp.ACLTemplateDatas[j] as ACLTemplateData;
                if (templateTemp.Id == aclTemplateId) {
                    return templateTemp.IsCheck;
                }
            }
        }
        return false;
    }

    GetTempResourceValue(aclTemplateId: string): [] {
        for (var i = 0; i < this.Temp.length; i++) {
            var categoryTemp = this.Temp[i];
            for (var j = 0; j < categoryTemp.ACLTemplateDatas.length; j++) {
                var templateTemp = categoryTemp.ACLTemplateDatas[j] as ACLTemplateData;
                if (templateTemp.Id == aclTemplateId) {
                    return templateTemp.ResourceUID;
                }
            }
        }
        return null;
    }

    @computedFrom('Categories')
    get SelectedItems() {
        //debugger;
        var result = [];
        for (var i = 0; i < this.Categories.length; i++) {
            var categoryVM = this.Categories[i];

            for (var j = 0; j < categoryVM.Templates.length; j++) {
                var templateVM = categoryVM.Templates[j];
                if (templateVM.IsCheck) {
                    result.push({
                        ACLTemplateId: templateVM.Id,
                        ResourceUId: templateVM.ResourceId
                    });
                }
            }
        }
        return result;
    }
}

class PermissionCategoryVM {
    Parent: PermissionVM;
    Templates: Array<PermissionTemplateVM>
    Id: string
    Name: string
    IsCheckCategory: boolean
    IsNotifiedByChildren: boolean;
    bindingEngine: BindingEngine;

    constructor() {
        var self = this;
        this.Templates = [];

        this.IsNotifiedByChildren = false;
        this.IsCheckCategory = false;
        this.bindingEngine = Container.instance.get(BindingEngine);

        this.bindingEngine.propertyObserver(this, 'IsCheckCategory')
            .subscribe((value) => {
                if (self.IsNotifiedByChildren == true) {

                    if (value == true) {

                        for (var i = 0; i < self.Templates.length; i++)
                            self.Templates[i].IsCheck = true;
                    }
                } else {

                    if (value == false) {

                        for (var i = 0; i < self.Templates.length; i++)
                            self.Templates[i].IsCheck = false;
                    }
                }
            });
    }

    LoadOriginalSource(originalSoruce: ACLTemplateCategoryData) {

        this.Id = originalSoruce.Id;
        this.Name = originalSoruce.Name;

        this.Templates = [];

        var self = this;
        this.IsCheckCategory = false;
        for (var i in originalSoruce.ACLTemplateDatas) {
            var templateData = originalSoruce.ACLTemplateDatas[i];
            var templateVM = new PermissionTemplateVM();
            templateVM.Parent = this;
            templateVM.OnIsCheckChange = function (value) {
                self.UpdateIsCheck(value);
            };
            templateVM.LoadOriginalSource(templateData);
            this.Templates.push(templateVM);
        }

        this.UpdateIsCheck(null);
    }

    UpdateIsCheck(value) {
        var self = this;
        self.IsNotifiedByChildren = false;

        var isCheckChild = true;
        for (var i = 0; i < self.Templates.length; i++) {
            if (self.Templates[i].IsCheck == false) {
                isCheckChild = false;
                self.IsNotifiedByChildren = true;
                break;
            }
        }
        //debugger
        self.IsCheckCategory = isCheckChild;
    }
}

class PermissionTemplateVM {
    Id: string
    Name: string
    ResourceType: string
    IsCheck: boolean
    IsRequireResourceType: boolean
    ResourceList: Array<ResourceData>;
    ResourceId: [];

    Parent: PermissionCategoryVM;

    OnIsCheckChange: (value) => void
    bindingEngine: BindingEngine;

    constructor() {
        var self = this;

        this.bindingEngine = Container.instance.get(BindingEngine);

        this.bindingEngine.propertyObserver(this, 'IsCheck')
            .subscribe((value) => {
                self.OnIsCheckChange(this);
            });
    }

    LoadOriginalSource(originalSource: ACLTemplateData) {

        this.Id = originalSource.Id;
        this.Name = originalSource.Name;
        this.ResourceType = originalSource.ResourceType;
        this.IsCheck = originalSource.IsCheck;
        this.IsRequireResourceType = originalSource.IsRequireResourceType;
        this.ResourceId = originalSource.ResourceUID;

        if (originalSource.IsRequireResourceType) {
            this.FindResource();
        }
    }

    FindResource() {
        var self = this;

        var service = Container.instance.get(ACLTemplateAppService) as ACLTemplateAppService;
        if (this.Parent.Parent.SelectedModule != null) {
            service.Init({ serverBaseUrl: this.Parent.Parent.SelectedModule.BaseUrl });
        }

        service.LoadResource(this.ResourceType).done(function (result) {
            self.ResourceList = result;
        }).fail(FsUtility.CommonErrorHandler);
    }
}
